import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", true);
    }
    return headers;
  },
});

export const bankSlice = createApi({
  reducerPath: "bankSlice",
  baseQuery,
  tagTypes: ["bank"],
  endpoints: (builder) => ({
    getBanks: builder.query({
      query: ({ page, limit, search, role }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);
        if (role) {
          params.append("role", role);
        }
        return `bank?${params.toString()}`;
      },
      providesTags: ["bank"],
    }),

    createBank: builder.mutation({
      query: (data) => ({
        url: "bank",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["bank"],
    }),

    updateBank: builder.mutation({
      query: ({ id, data }) => ({
        url: `bank/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["bank"],
    }),
  }),
});

export const {
  useGetBanksQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
} = bankSlice;
